import React, { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import * as Yup from 'yup'
import { Formik } from 'formik'
import {
    Box,
    Button,
    Container,
    Link,
    TextField,
    Typography,
    // Grid,
    makeStyles,
    CircularProgress
} from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
// import FacebookIcon from 'src/icons/Facebook';
// import GoogleIcon from 'src/icons/Google';
// import AppleIcon from 'src/icons/Apple';
import Page from '../../components/Page'
import firebase from 'firebase/app'

import 'firebase/auth'
import 'firebase/functions'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        height: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    alert: {
        marginBottom: theme.spacing(3)
    }
}))

const LoginView = () => {
    const classes = useStyles()
    const [formValidateError, setformValidateError] = useState()

    async function signIn(values) {
        return firebase
            .auth()
            .signInWithEmailAndPassword(values.email, values.password)
            .then((user) => {
                user.user.getIdTokenResult().then((res) => {
                    if (!res.claims.admin) {
                        setformValidateError(
                            'Unauthorized account identifiers. Contact your developer team for authorization.'
                        )
                    }
                })
            })
            .catch((error) => {
                setformValidateError(error.message)
                console.log(error)
            })
    }

    return (
        <Page className={classes.root} title="Login">
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
            >
                <Container maxWidth="sm">
                    {formValidateError ? (
                        <Box mb={3}>
                            <Alert
                                severity="error"
                                onClose={() => setformValidateError(null)}
                                className={classes.alert}
                            >
                                <AlertTitle>Error</AlertTitle>
                                {formValidateError}
                            </Alert>
                        </Box>
                    ) : null}
                    <Formik
                        initialValues={{
                            email: '',
                            password: ''
                        }}
                        validationSchema={Yup.object().shape({
                            email: Yup.string()
                                .email('Must be a valid email')
                                .max(255)
                                .required('Email is required'),
                            password: Yup.string()
                                .max(255)
                                .required('Password is required')
                        })}
                        onSubmit={(values) => signIn(values)}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mb={3}>
                                    <Typography
                                        color="textPrimary"
                                        variant="h2"
                                    >
                                        Sign in
                                    </Typography>
                                    <Typography
                                        color="textSecondary"
                                        gutterBottom
                                        variant="body2"
                                    >
                                        Sign in on the internal platform
                                    </Typography>
                                </Box>
                                {/* <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <Button
                      color="primary"
                      fullWidth
                      endIcon={<FacebookIcon />}
                      onClick={handleSubmit}
                      size="large"
                      variant="contained"
                    >
                      Login with
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button
                      fullWidth
                      endIcon={<GoogleIcon />}
                      onClick={handleSubmit}
                      size="large"
                      variant="contained"
                    >
                      Login with
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button
                      fullWidth
                      endIcon={<AppleIcon />}
                      onClick={handleSubmit}
                      size="large"
                      variant="contained"
                    >
                      Login with
                    </Button>
                  </Grid>
                </Grid> */}
                                {/* <Box mt={3} mb={1}>
                  <Typography
                    align="center"
                    color="textSecondary"
                    variant="body1"
                  >
                    or login with email address
                  </Typography>
                </Box> */}
                                <TextField
                                    error={Boolean(
                                        touched.email && errors.email
                                    )}
                                    fullWidth
                                    helperText={touched.email && errors.email}
                                    label="Email Address"
                                    margin="normal"
                                    name="email"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="email"
                                    value={values.email}
                                    variant="outlined"
                                />
                                <TextField
                                    error={Boolean(
                                        touched.password && errors.password
                                    )}
                                    fullWidth
                                    helperText={
                                        touched.password && errors.password
                                    }
                                    label="Password"
                                    margin="normal"
                                    name="password"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="password"
                                    value={values.password}
                                    variant="outlined"
                                />
                                <Box my={2}>
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting}
                                        fullWidth
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                    >
                                        {isSubmitting ? (
                                            <CircularProgress />
                                        ) : (
                                            'Sign in now'
                                        )}
                                    </Button>
                                </Box>
                                <Typography
                                    color="textSecondary"
                                    variant="body1"
                                >
                                    <Link
                                        component={RouterLink}
                                        to="/forgot-password"
                                        variant="h6"
                                    >
                                        Forgot Password?
                                    </Link>
                                </Typography>
                            </form>
                        )}
                    </Formik>
                    {/* <Box>
            <Button
              color="primary"
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              onClick={async () => {
                await firebase
                  .functions()
                  .httpsCallable('addAuthorizationRole-AddAuthorizationRole')({
                    type: 'admin',
                    email: 'oguzxan.ali@gmail.com'
                  })
                  .then((res) => {
                    console.log('AddAuthorizationRole success', res);
                  })
                  .catch((e) => console.log(e));
                // admin
                //   .auth()
                //   .getUserByEmail('oguzxan.ali@gmail.com')
                //   .then((user) => {
                //     // Confirm user is verified.
                //     if (user.emailVerified) {
                //       // Add custom claims for additional privileges.
                //       // This will be picked up by the user on token refresh or next sign in
                //       return admin
                //         .auth()
                //         .setCustomUserClaims(user.uid, {
                //           admin: true
                //         })
                //         .then(() => {
                //           console.log('user Successfully became an admin');
                //           return null;
                //         })
                //         .catch((e) => console.log(e));
                //     }
                //     return null;
                //   })
                //   .catch((error) => {
                //     console.log(error);
                //   });
              }}
            >
              ADD ADMIN AUTHORIZATION
            </Button>
          </Box> */}
                </Container>
            </Box>
        </Page>
    )
}

export default LoginView
